import { render, staticRenderFns } from "./scoreTen.vue?vue&type=template&id=4ff9d701"
import script from "./scoreTen.vue?vue&type=script&lang=js"
export * from "./scoreTen.vue?vue&type=script&lang=js"
import style0 from "./scoreTen.vue?vue&type=style&index=0&id=4ff9d701&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports